/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
} from "../../runtime/index.jsx";
export function Componente_MDolar_77_36(e, t) {
  return (
    <li
      key={t}
      className={`flex flex-wrap justify-between gap-2`}
      children={[
        <span className={`text-(--text)`} children={e.campo} />,
        <span className={`text-(--text-h)`} children={e.valor} />,
      ]}
    />
  );
}
